import { Controller } from "@hotwired/stimulus";
import { orderBy, shuffle } from "lodash";
import { WishlistIcon } from "../components";
import { checkAppmate } from "../helpers";

export default class extends Controller {
  static targets = ["productGrid", "loader", "wrap"];
  static values = {
    pages: Number,
    currentPage: Number,
  };

  initialize() {
    this.params = new URLSearchParams(window.location.search);
    this.basePage = parseInt(this.params.get("page") || 1);

    this.handleWishlistState();
    const collection = window.location.pathname.split("/").pop();

    if (
      !this.params.get("sort_by") &&
      (collection === "fabric" ||
        collection === "wallpaper" ||
        collection === "decorating")
    ) {
      this.productGridTarget.innerHTML = this.organiseProducts(
        this.productGridTarget
      ).innerHTML;
    }

    this.element.classList.remove("collection--loading");

    setTimeout(() => {
      this.handleScroll();
    }, 300);

    // Track the last viewed collection
    // sessionStorage.setItem("last_collection", location.pathname);

    let visitedCollections =
      JSON.parse(sessionStorage.getItem("visited_collections")) || [];

    visitedCollections.push(location.pathname);

    if (visitedCollections.length > 2) {
      visitedCollections = visitedCollections.slice(-2);
    }

    sessionStorage.setItem(
      "visited_collections",
      JSON.stringify(visitedCollections)
    );
  }

  handleWishlistState(scope = "main") {
    const handleState = () =>
      document.querySelectorAll(".product-card__wishlist").forEach((elem) => {
        elem.innerHTML = WishlistIcon(
          elem.dataset.variantId,
          elem.parentElement.parentElement.dataset.productCardProductValue
        );
        elem.classList.remove("product-card__wishlist--hidden");
      });

    checkAppmate(handleState);
  }

  organiseProducts(target = this.productGridTarget) {
    const cards = target.querySelectorAll(".product-card");
    let firstOfType = [];
    let rest = [];

    if (cards.length > 0) {
      cards.forEach((card) => {
        if (
          firstOfType.find(
            (_card) =>
              _card.dataset.productCardProductValue ===
              card.dataset.productCardProductValue
          )
        ) {
          rest.push(card);
        } else {
          firstOfType.push(card);
        }
      });
    }

    rest = orderBy(rest, ["variantTitle"], ["asc"]);

    const organisedCards = firstOfType.concat(rest);
    const cardWrapper = document.createElement("div");
    organisedCards.forEach((card) => {
      cardWrapper.appendChild(card);
    });

    return cardWrapper;
  }

  /**
   * Set last viewed item to session storage
   * - Automatically Scrolls user to last viewed product if they go back...
   *  */

  handleScroll() {
    if (
      sessionStorage.getItem("ref_id") &&
      sessionStorage.getItem("visited_collections")
    ) {
      const target = document.querySelector(
        `[data-product-card-variant-value="${sessionStorage.getItem(
          "ref_id"
        )}"]`
      );

      const visitedCollections = JSON.parse(
        sessionStorage.getItem("visited_collections")
      );

      if (
        target &&
        location.pathname === visitedCollections[0] &&
        visitedCollections[0] === visitedCollections[1]
      ) {
        window.scroll({ top: target.offsetTop, behavior: "smooth" });
      }
    }
  }

  handleLink(e) {
    const { id, page } = e.params;
    sessionStorage.setItem("ref_id", id);

    if (page) {
      const params = new URLSearchParams(window.location.search);
      params.set("page", page);

      const url =
        window.location.origin +
        window.location.pathname +
        `?${params.toString()}`;

      history.replaceState({}, "", url);
    }
  }

  async handlePaginate(e) {
    const { href } = e.target;
    e.preventDefault();
    this.loaderTarget.classList.remove("hidden");
    try {
      const res = await fetch(href);

      if (res.ok) {
        const responseText = (await res?.text()) || null;
        const html = document.createElement("div");
        html.innerHTML = responseText;

        const next = document.querySelector('a[data-direction="next"]');
        const prev = document.querySelector('a[data-direction="prev"]');

        const newProductGrid = html.querySelector(".collection-products");

        const params = new URLSearchParams(window.location.search);
        const page = new URL(e.target.href).searchParams;

        params.delete("page");
        params.append("page", page.get("page"));

        const updatedURL = `${window.location.origin}${
          window.location.pathname
        }?${params.toString()}`;
        history.replaceState({}, "", updatedURL);

        const paginateNext = html.querySelector('a[data-direction="next"]');
        const paginatePrev = html.querySelector('a[data-direction="prev"]');

        if (!paginateNext.classList.contains("hidden")) {
          if (e.target.dataset.direction == "next") {
            next.href = paginateNext.href;
          }

          this.currentPage <= this.pagesValue &&
            next.classList.remove("hidden");
        } else {
          next.classList.add("hidden");
        }

        if (this.basePage > 1 && !paginatePrev.classList.contains("hidden")) {
          if (e.target.dataset.direction == "prev") {
            prev.href = paginatePrev.href;
          }
          this.pageLow > 1 && prev.classList.remove("hidden");
        } else {
          prev.classList.add("hidden");
        }

        if (e.target.dataset.direction === "prev") {
          this.currentPageValue = page.get("page");

          this.productGridTarget.innerHTML =
            this.organiseProducts(newProductGrid).innerHTML +
            this.productGridTarget.innerHTML;
        } else if (e.target.dataset.direction === "next") {
          this.currentPageValue = page.get("page");
          this.productGridTarget.innerHTML +=
            this.organiseProducts(newProductGrid).innerHTML;
        }

        this.handleWishlistState(".collection-products");
      }
    } catch (err) {
      console.error("There was an error fetching the next page", err);
    } finally {
      this.loaderTarget.classList.add("hidden");
    }
  }

  handleSortChange(e) {
    this.currentPageValue = 1;
    const sortValue = e.currentTarget.value;

    const params = this.params;
    params.set("sort_by", sortValue);

    const query = params.toString();
    window.location =
      window.location.origin + window.location.pathname + "?" + query;
  }

  updateLayout(e) {
    let layout = sessionStorage.getItem("layout");

    if (e) {
      layout = e.params.layout;
      sessionStorage.setItem("layout", layout);
    }

    if (layout) {
      const modifier = [...this.productGridTarget.classList].find((_class) =>
        _class.includes("--")
      );

      this.productGridTarget.classList.replace(
        modifier,
        `collection-products--${layout}`
      );
    }
  }

  handleShuffle(target) {
    const cards = [...target.querySelectorAll(".product-card")];

    if (this.params.get("sort_by")) return cards;

    const orderedCards = cards.sort((a, b) => {
      return a.dataset.variantTitle.localeCompare(b.dataset.variantTitle);
    });

    return orderedCards;
  }
}
